<app-private-layout [layoutWidth]="layoutSize" [layoutColor]="layoutColor" *ngIf="layoutType==='vertical'">
</app-private-layout>
